'use client';

import React from 'react';
import EnvContext from './EnvContext';

export default function EnvProvider({ env, children }) {
	return (
		<EnvContext.Provider value={{ env }}>
			{children}
		</EnvContext.Provider>
	);
}
